import React, { Component } from 'react';
import { Modal, Table, Button, message, Spin, Alert, Tag, Tooltip } from 'antd';
import { FilePdfOutlined, FileExcelOutlined, DownloadOutlined, CheckCircleOutlined, ClockCircleOutlined, EyeOutlined, FileTextOutlined } from '@ant-design/icons';
import { getProjectRamsReport, downloadRamsSignOffSheet, downloadRamsFullWithSignOff, downloadRamsRevisionSheet } from '../../HttpRequests/ramsControlCentre';
import { get } from 'lodash';
import PropTypes from 'prop-types';
import moment from 'moment';

class RamsProjectReportsModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      visible: false,
      loading: false,
      ramsRecords: [],
      project: null,
      downloadingExcel: false,
      downloadingPdf: false,
      downloadingSignOff: {},
      downloadingFull: {},
      downloadingRevision: {},
    };
  }

  show = function (project) {
    var self = this;
    self.setState({
      visible: true,
      project: project,
      loading: true,
    });

    getProjectRamsReport(project.id).then(function (response) {
      self.setState({
        ramsRecords: (response.data && response.data.rams_records) || [],
        project: (response.data && response.data.project) || project,
      });
    }).catch(function (error) {
      console.error('Failed to load RAMS report:', error);
      message.error('Failed to load RAMS report for this project');
    }).then(function () {
      self.setState({ loading: false });
    });
  };

  hide = function () {
    this.setState({
      visible: false,
      ramsRecords: [],
      project: null,
      downloadingExcel: false,
      downloadingPdf: false,
    });
  };

  handleDownloadExcel = function () {
    var project = this.state.project;
    if (!project) return;

    var teamSlug = get(window, 'state.currentTeam.slug');
    var url = '/exports/teams/' + teamSlug + '/projects/' + project.id + '/rams-report-excel';
    window.open(url, '_blank');
  };

  handleDownloadPdf = function () {
    var project = this.state.project;
    if (!project) return;

    var teamSlug = get(window, 'state.currentTeam.slug');
    var url = '/exports/teams/' + teamSlug + '/projects/' + project.id + '/rams-report-pdf';
    window.open(url, '_blank');
  };

  handleDownloadSignOff = function (ramsRecordId) {
    var self = this;
    self.setState(function (prev) {
      var s = Object.assign({}, prev.downloadingSignOff);
      s[ramsRecordId] = true;
      return { downloadingSignOff: s };
    });
    downloadRamsSignOffSheet(ramsRecordId).then(function (response) {
      if (response.data && response.data.download_url) {
        window.open(response.data.download_url, '_blank');
      }
    }).catch(function (err) {
      var msg = err.response && err.response.data && err.response.data.error
        ? err.response.data.error
        : 'Sign-off sheet not yet available';
      message.error(msg);
    }).then(function () {
      self.setState(function (prev) {
        var s = Object.assign({}, prev.downloadingSignOff);
        s[ramsRecordId] = false;
        return { downloadingSignOff: s };
      });
    });
  };

  handleDownloadRevision = function (ramsRecordId) {
    var self = this;
    self.setState(function (prev) {
      var s = Object.assign({}, prev.downloadingRevision);
      s[ramsRecordId] = true;
      return { downloadingRevision: s };
    });
    downloadRamsRevisionSheet(ramsRecordId).then(function (response) {
      var blob = new Blob([response.data], { type: 'application/pdf' });
      var url = window.URL.createObjectURL(blob);
      var link = document.createElement('a');
      link.href = url;
      link.download = 'RAMS_Revisions_' + ramsRecordId + '_' + moment().format('YYYY-MM-DD') + '.pdf';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    }).catch(function (err) {
      var msg = err.response && err.response.data && err.response.data.error
        ? err.response.data.error
        : 'Could not generate revision sheet';
      message.error(msg);
    }).then(function () {
      self.setState(function (prev) {
        var s = Object.assign({}, prev.downloadingRevision);
        s[ramsRecordId] = false;
        return { downloadingRevision: s };
      });
    });
  };

  handleDownloadFull = function (ramsRecordId) {
    var self = this;
    self.setState(function (prev) {
      var s = Object.assign({}, prev.downloadingFull);
      s[ramsRecordId] = true;
      return { downloadingFull: s };
    });
    downloadRamsFullWithSignOff(ramsRecordId).then(function (response) {
      var blob = new Blob([response.data], { type: 'application/pdf' });
      var url = window.URL.createObjectURL(blob);
      var link = document.createElement('a');
      link.href = url;
      link.download = 'RAMS_Full_SignOff_' + ramsRecordId + '_' + moment().format('YYYY-MM-DD') + '.pdf';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    }).catch(function (err) {
      var msg = err.response && err.response.data && err.response.data.error
        ? err.response.data.error
        : 'Could not generate combined PDF';
      message.error(msg);
    }).then(function () {
      self.setState(function (prev) {
        var s = Object.assign({}, prev.downloadingFull);
        s[ramsRecordId] = false;
        return { downloadingFull: s };
      });
    });
  };

  getStatusTag = function (record) {
    if (record.total === 0) {
      return React.createElement(Tag, { color: 'default' }, 'No Records');
    }
    if (record.completion_rate >= 100) {
      return React.createElement(Tag, { icon: React.createElement(CheckCircleOutlined, null), color: 'success' }, 'Complete');
    }
    if (record.completion_rate >= 50) {
      return React.createElement(Tag, { icon: React.createElement(ClockCircleOutlined, null), color: 'processing' }, 'In Progress');
    }
    return React.createElement(Tag, { icon: React.createElement(ClockCircleOutlined, null), color: 'warning' }, 'Pending');
  };

  render() {
    var self = this;
    var visible = this.state.visible;
    var loading = this.state.loading;
    var ramsRecords = this.state.ramsRecords;
    var project = this.state.project;
    var downloadingSignOff = this.state.downloadingSignOff;
    var downloadingFull = this.state.downloadingFull;
    var downloadingRevision = this.state.downloadingRevision;

    var totalSigned = 0;
    var totalPending = 0;
    ramsRecords.forEach(function (rec) {
      totalSigned += rec.total_signed;
      totalPending += rec.total_pending;
    });
    var hasSignedRecords = totalSigned > 0;

    var expandedRowRender = function (record) {
      if (!record.subcontractors || record.subcontractors.length === 0) {
        return React.createElement('div', { style: { padding: '8px 0', color: '#999' } }, 'No signing records.');
      }

      var subColumns = [
        {
          title: 'Subcontractor',
          dataIndex: 'subcontractor_name',
          key: 'subcontractor_name',
        },
        {
          title: 'Status',
          key: 'status',
          width: 120,
          render: function (text, row) {
            if (row.signed) {
              return React.createElement(Tag, { icon: React.createElement(CheckCircleOutlined, null), color: 'success' }, 'Signed');
            }
            if (row.viewed) {
              return React.createElement(Tag, { icon: React.createElement(EyeOutlined, null), color: 'processing' }, 'Viewed');
            }
            return React.createElement(Tag, { icon: React.createElement(ClockCircleOutlined, null), color: 'warning' }, 'Pending');
          },
        },
        {
          title: 'Sent',
          dataIndex: 'sent_at',
          key: 'sent_at',
          render: function (text) {
            return text ? moment(text).format('DD/MM/YYYY HH:mm') : '-';
          },
        },
        {
          title: 'Signed At',
          dataIndex: 'signed_at',
          key: 'signed_at',
          render: function (text) {
            return text ? moment(text).format('DD/MM/YYYY HH:mm') : '-';
          },
        },
        {
          title: 'PDF',
          key: 'download',
          width: 70,
          render: function (text, row) {
            if (!row.signed) return null;
            if (row.signed_pdf_url) {
              return React.createElement(
                Tooltip,
                { title: 'Download Signed PDF' },
                React.createElement(
                  'a',
                  { href: row.signed_pdf_url, target: '_blank', rel: 'noopener noreferrer' },
                  React.createElement(DownloadOutlined, { style: { fontSize: 18, color: '#1890FF' } })
                )
              );
            }
            return React.createElement(
              Tooltip,
              { title: 'Signed PDF not yet available' },
              React.createElement(DownloadOutlined, { style: { fontSize: 18, color: '#ccc', cursor: 'not-allowed' } })
            );
          },
        },
      ];

      return React.createElement(Table, {
        dataSource: record.subcontractors,
        rowKey: 'id',
        columns: subColumns,
        pagination: false,
        size: 'small',
        style: { margin: '0 0 0 20px' },
      });
    };

    var columns = [
      {
        title: 'RAMS ID',
        key: 'id',
        width: 100,
        render: function (text, record) {
          return 'RAMS ' + record.id;
        },
      },
      {
        title: 'Status',
        key: 'status',
        render: function (_, record) {
          return self.getStatusTag(record);
        },
      },
      {
        title: 'Valid Period',
        key: 'valid_period',
        render: function (_, record) {
          var from = record.valid_from ? moment(record.valid_from).format('DD/MM/YYYY') : '';
          var to = record.valid_to ? moment(record.valid_to).format('DD/MM/YYYY') : '';
          if (!from && !to) return '-';
          return from + ' - ' + to;
        },
      },
      {
        title: 'Signed',
        key: 'signed',
        width: 80,
        render: function (_, record) {
          return React.createElement('span', { style: { color: '#52c41a', fontWeight: 'bold' } }, record.total_signed);
        },
      },
      {
        title: 'Pending',
        key: 'pending',
        width: 80,
        render: function (_, record) {
          return React.createElement('span', { style: { color: record.total_pending > 0 ? '#faad14' : '#999' } }, record.total_pending);
        },
      },
      {
        title: 'Completion',
        key: 'completion',
        width: 100,
        render: function (_, record) {
          return React.createElement(
            'div', null,
            React.createElement('div', { style: { fontWeight: 'bold' } }, record.completion_rate + '%'),
            React.createElement('div', { style: { fontSize: '11px', color: '#666' } },
              record.total_signed + '/' + record.total
            )
          );
        },
        sorter: function (a, b) {
          return a.completion_rate - b.completion_rate;
        },
      },
      {
        title: 'Sign-off Sheet',
        key: 'signoff',
        width: 110,
        render: function (_, record) {
          if (record.total_signed === 0) return null;
          var loading = downloadingSignOff[record.id];
          return React.createElement(
            Tooltip,
            { title: loading ? 'Downloading...' : 'Download sign-off sheet' },
            React.createElement(FileTextOutlined, {
              style: { fontSize: 18, color: loading ? '#ccc' : '#52c41a', cursor: loading ? 'wait' : 'pointer' },
              onClick: loading ? null : function () { self.handleDownloadSignOff(record.id); },
            })
          );
        },
      },
      {
        title: 'Revision Sheet',
        key: 'revision',
        width: 115,
        render: function (_, record) {
          var loading = downloadingRevision[record.id];
          return React.createElement(
            Tooltip,
            { title: loading ? 'Generating...' : 'Download revision sheet' },
            React.createElement(FileTextOutlined, {
              style: { fontSize: 18, color: loading ? '#ccc' : '#fa8c16', cursor: loading ? 'wait' : 'pointer' },
              onClick: loading ? null : function () { self.handleDownloadRevision(record.id); },
            })
          );
        },
      },
      {
        title: 'Full Document',
        key: 'fullsignoff',
        width: 140,
        render: function (_, record) {
          if (record.total_signed === 0) return null;
          var loading = downloadingFull[record.id];
          return React.createElement(
            Tooltip,
            { title: loading ? 'Generating...' : 'Download full document (+sign off +revision)' },
            React.createElement(FilePdfOutlined, {
              style: { fontSize: 18, color: loading ? '#ccc' : '#722ed1', cursor: loading ? 'wait' : 'pointer' },
              onClick: loading ? null : function () { self.handleDownloadFull(record.id); },
            })
          );
        },
      },
    ];

    return React.createElement(
      Modal,
      {
        title: React.createElement(
          'div',
          { style: { display: 'flex', alignItems: 'center' } },
          React.createElement(FilePdfOutlined, { style: { marginRight: 8, color: '#1890ff' } }),
          'RAMS Reports - ' + (project ? 'Project ' + project.number : 'Loading...')
        ),
        visible: visible,
        onCancel: function () { self.hide(); },
        width: 1000,
        footer: [
          React.createElement(
            Button,
            {
              key: 'excel',
              icon: React.createElement(FileExcelOutlined, null),
              onClick: function () { self.handleDownloadExcel(); },
              disabled: !hasSignedRecords && totalPending === 0,
            },
            'Download Excel'
          ),
          React.createElement(
            Button,
            {
              key: 'pdf',
              type: 'primary',
              icon: React.createElement(DownloadOutlined, null),
              onClick: function () { self.handleDownloadPdf(); },
              disabled: !hasSignedRecords,
            },
            'Download All Signed PDFs'
          ),
          React.createElement(
            Button,
            { key: 'close', onClick: function () { self.hide(); } },
            'Close'
          ),
        ],
      },
      project && React.createElement(Alert, {
        message: 'RAMS Reports for Project ' + project.number,
        description: (project.title || '') + ' - Showing all RAMS records and signing status. Use the buttons below to download reports.',
        type: 'info',
        showIcon: true,
        style: { marginBottom: 20 },
      }),
      totalSigned > 0 || totalPending > 0 ? React.createElement(
        Alert,
        {
          message: 'Summary: ' + totalSigned + ' signed, ' + totalPending + ' pending across ' + ramsRecords.length + ' RAMS record(s)',
          type: totalPending === 0 ? 'success' : 'warning',
          showIcon: true,
          style: { marginBottom: 16 },
        }
      ) : null,
      React.createElement(
        Spin,
        { spinning: loading },
        ramsRecords.length === 0 && !loading
          ? React.createElement(Alert, {
              message: 'No RAMS Records Found',
              description: 'No RAMS records have been created for this project.',
              type: 'warning',
              showIcon: true,
            })
          : React.createElement(Table, {
              columns: columns,
              dataSource: ramsRecords,
              rowKey: 'id',
              expandable: {
                expandedRowRender: expandedRowRender,
              },
              pagination: {
                pageSize: 10,
                showSizeChanger: true,
                showTotal: function (total, range) {
                  return range[0] + '-' + range[1] + ' of ' + total + ' RAMS records';
                },
              },
            })
      ),
      React.createElement(
        'div',
        { style: { marginTop: 16, fontSize: '12px', color: '#666' } },
        React.createElement('strong', null, 'Note: '),
        'The Excel report contains all signed and pending records. The PDF download amalgamates all signed RAMS documents into a single PDF file.'
      )
    );
  }
}

RamsProjectReportsModal.propTypes = {};

export default RamsProjectReportsModal;
